<form [formGroup]="form">
  <ng-container *ngIf="strankaCtrl?.get('naziv') as strankaNazivCtrl">
    <p-autoComplete
      #autocompleteRef
      [suggestions]="strankaSuggestionsStr"
      formControlName="searchValue"
      (completeMethod)="handleSearch($event)"
      (onSelect)="handleSelectChange($event)"
      placeholder="Naziv, Pib ili Jbkjs stranke..."
      [appendTo]="parentCtrl"
      (onClear)="handleClear()"
      emptyMessage="Stranka nije pronađena"
      dropdownMode="current"
      [disabled]="shouldDisable"
      [inputStyleClass]="
        strankaNazivCtrl.invalid &&
        (strankaNazivCtrl.dirty || strankaNazivCtrl.touched)
          ? 'p-invalid'
          : ''
      "
    >
    </p-autoComplete>
    <kodit-error-info-required
      [formCtrl]="strankaNazivCtrl"
    ></kodit-error-info-required>
  </ng-container>
</form>
